import React from 'react'

function Discount() {
  return (
    <div className='p-3 discount mt-3'>
        <span className='dicount_text'>Bravo bonus kartı əlavə et cashback qazan.</span>
    </div>
  )
}

export default Discount